import { createApp } from 'vue';
import ServicePerformanceModal from './ServicePerformanceModal.vue';
import AdvancedSearchFilters from './AdvancedSearchFilters.vue';
import EditWaypointModal from './EditWaypointModal.vue';
import ShipmentActivityPane from './ShipmentActivityPane.vue';
import ShipmentCustomCreateModal from './ShipmentCustomCreateModal.vue';
import ShipmentFilesPane from './ShipmentFilesPane.vue';
import { registerEditWaypointModalApi } from './edit-waypoint-modal-controller';

let servicePerformanceAppMounted = false;
let advancedSearchFiltersAppMounted = false;
let editWaypointAppMounted = false;
let shipmentActivityAppMounted = false;
let shipmentCustomCreateAppMounted = false;
let shipmentFilesAppMounted = false;

export function initServicePerformanceModal() {
  const mountElement = document.getElementById('servicePerformanceRoot');

  if (!mountElement || servicePerformanceAppMounted) {
    return;
  }

  const app = createApp(ServicePerformanceModal);
  app.mount(mountElement);
  servicePerformanceAppMounted = true;
}

export function initAdvancedSearchFilters() {
  const mountElement = document.getElementById('advancedSearchFiltersRoot');

  if (!mountElement || advancedSearchFiltersAppMounted) {
    return;
  }

  const app = createApp(AdvancedSearchFilters);
  app.mount(mountElement);
  advancedSearchFiltersAppMounted = true;
}

export function initShipmentActivityPane() {
  const mountElement = document.getElementById('shipmentActivityRoot');

  if (!mountElement || shipmentActivityAppMounted) {
    return;
  }

  const app = createApp(ShipmentActivityPane);
  app.mount(mountElement);
  shipmentActivityAppMounted = true;
}

export function initShipmentCustomCreateModal() {
  const mountElement = document.getElementById('shipmentCustomCreateRoot');

  if (!mountElement || shipmentCustomCreateAppMounted) {
    return;
  }

  const app = createApp(ShipmentCustomCreateModal);
  app.mount(mountElement);
  shipmentCustomCreateAppMounted = true;
}

export function initEditWaypointModal() {
  const mountElement = document.getElementById('editWaypointRoot');

  if (!mountElement || editWaypointAppMounted) {
    return;
  }

  registerEditWaypointModalApi();
  const app = createApp(EditWaypointModal);
  app.mount(mountElement);
  editWaypointAppMounted = true;
}

export function initShipmentFilesPane() {
  const mountElement = document.getElementById('shipmentFilesRoot');

  if (!mountElement || shipmentFilesAppMounted) {
    return;
  }

  const app = createApp(ShipmentFilesPane);
  app.mount(mountElement);
  shipmentFilesAppMounted = true;
}

export default initServicePerformanceModal;
